<template>
  <div v-if="filteredListToRender.length > 0" class="col-xs-12 reg-body-mg pl-20 pr-20">
    <permission-access-modal></permission-access-modal>
    <loader :loadingStatus="loaderStatus"></loader>
    <registration-details-popup
      :permissions="permissions"
      :dataRow="activeProductRegistration"
      @hidePopup="hidePopup"
      :reportFlag="true"
    ></registration-details-popup>
    <div
      class="notification-box row font-properties"
      :key="index"
      v-for="(regObj, index) in filteredListToRender"
    >
      <!-- Header -->
      <div class="col-xs-12 p-0 mb-15">
        <div class="col-xs-10 p-0 regupdate-title d-flex align-items-start">
          <div class="dropdown" id="trackerActionDots" v-if="!isFromGlobalSearch">
            <button class="menu-btn dropdown-toggle" type="button" data-toggle="dropdown">
              <i class="fa fa-ellipsis-v menu-dots"></i>
            </button>
            <ul class="dropdown-menu left-actions p-0">
              <li
                v-if="
                  regObj.isFlagged &&
                  permissions.includes('REG_WTCH_REG_UPD_UNFLAG') &&
                  selectedMenu !== 'archive'
                "
                class="font-16 text-primary d-flex align-items-center"
                @click="updateFlag(false, regObj.regUpdateId, regObj.countryId)"
              >
                <img
                  class="cursor-pointer img-16"
                  src="/static/images/icons/flag_icon_active.svg"
                  alt
                />
                <span class="pl-15">Flag Update</span>
              </li>
              <li
                v-if="
                  !regObj.isFlagged &&
                  permissions.includes('REG_WTCH_REG_UPD_FLAG') &&
                  selectedMenu !== 'archive'
                "
                class="font-16 text-primary d-flex align-items-center"
                @click="updateFlag(true, regObj.regUpdateId, regObj.countryId)"
              >
                <img class="cursor-pointer img-16" src="/static/images/icons/flag_icon.svg" alt />
                <span class="pl-15">Flag Update</span>
              </li>
              <li
                v-if="
                  permissions.includes('REG_WTCH_REG_UPD_LINE_ARCHIVE') &&
                  !['new', 'archive'].includes(selectedMenu)
                "
                class="font-16 text-primary d-flex align-items-center"
                @click="archiveRegulatory(regObj.regUpdateId, regObj.countryId)"
              >
                <img
                  src="/static/images/reg-watch/archive_icon.svg"
                  alt
                  class="cursor-pointer img-16"
                />
                <span class="pl-15">Archive</span>
              </li>
              <li
                v-if="
                  permissions.includes('REG_WTCH_REG_UPD_UNARCHIVE') && selectedMenu === 'archive'
                "
                class="font-16 text-primary d-flex align-items-center"
                @click="unArchiveRegulatory(regObj.regUpdateId)"
              >
                <img
                  class="cursor-pointer img-16"
                  src="/static/images/reg-watch/unarchive_icon.svg"
                  alt
                />
                <span class="pl-15">Un-archive</span>
              </li>
            </ul>
          </div>
          <div
            class="word-break pl-15 font-medium reg-title"
            v-html="$options.filters.highlight(regObj.title, searchRegulatory)"
          ></div>
        </div>
        <div
          class="col-xs-2 p-0 text-right"
          v-if="
            selectedMenu === 'new' &&
            permissions.includes('REG_WTCH_REG_UPD_CLOSE') &&
            !isFromGlobalSearch
          "
        >
          <img
            class="cursor-pointer"
            src="/static/images/icons/close_icon.svg"
            alt
            @click="deleteRegulatoryFromNew(regObj.regUpdateId, regObj.countryId)"
          />
        </div>
      </div>
      <!-- Content -->
      <div class="col-xs-12 reg-content">
        <div class="col-xs-12 p-0 mb-15" v-if="regObj.effectiveDate">
          <span class="font-medium text-secondary">Effective date:</span>
          <span class="font-300"> {{ regObj.effectiveDate }} </span>
        </div>
        <!-- Country -->
        <div class="col-xs-12 p-0 mb-10 d-flex align-items-center">
          <span class="flag-icon flag-icon-squared" :class="countryFlag(regObj.countryCode)"></span>
          <span class="pl-10 font-medium text-secondary">{{ regObj.countryName }}</span>
        </div>
        <!-- Links -->
        <div class="col-xs-12 p-0 pb-5" v-if="regObj.linkList && regObj.linkList.length">
          <ul class="ul-list">
            <li class="p-0 word-break" v-for="(linkDetail, index) in regObj.linkList" :key="index">
              <a :href="linkDetail['link']" target="_blank">{{ linkDetail['label'] }}</a>
            </li>
          </ul>
        </div>
        <div class="col-xs-12 p-0 mb-25" v-if="regObj.publishedDate">
          <span class="font-medium text-secondary">Published On:</span>
          <span class="font-300"> {{ regObj.publishedDate }} </span>
        </div>
        <div class="col-xs-12 p-0">
          <div class="d-flex justify-space-between">
            <!-- Registrations effected -->
            <div class="d-flex">
              <div class="text-primary font-medium">
                {{
                  regObj.productCount === 0
                    ? 'No registrations'
                    : `${regObj.productCount} registrations`
                }}
                affected
              </div>
              <div class="dropdown pl-5" v-if="regObj.productCount">
                <button
                  class="menu-btn dropdown-toggle arrow-open"
                  type="button"
                  data-toggle="dropdown"
                >
                  <img src="/static/images/icons/chevron_down.svg" />
                </button>
                <div
                  class="dropdown-menu reg-affected"
                  :class="{ 'display-none': !regObj.productList.length }"
                >
                  <ul
                    role="menu"
                    class="product-list p-0 mb-0"
                    v-if="regObj.productList.length > 0"
                  >
                    <li
                      class="ft-wt-normal font-16 cursor-pointer text-primary"
                      v-for="(product, index) in regObj.productList"
                      :key="index"
                      @click="getProductRelatedDetails(product.regId)"
                    >
                      {{
                        product.name && product.name.length > 15
                          ? `${product.name.substr(0, 14)}...`
                          : product.name
                      }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="font-medium learn-more-text">
              <span class="cursor-pointer" @click="openDescriptionModal(regObj)">Learn more</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <regwatch-description-modal :regWatch="selectedRegWatch"></regwatch-description-modal>
  </div>
  <div v-else class="col-md-12 col-sm-12 col-xs-12 mt-25 font-properties">
    <div class="col-md-offset-4 col-xs-offset-2">No Regulatory Updates Found</div>
  </div>
</template>
<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
// import EventBus from '../../utils/event-bus';
import registrationDetailsPopup from '../Registrations/RegistrationDetailsPopup.vue';
import PermissionAccessModal from '../Common/PermissionAccessModal.vue';
import RegwatchDescriptionModal from './RegwatchDescriptionModal.vue';
import { getRegistrationDetailsById } from '../../apis/registrations';
import constructRegistrationObject from '../../utils/registrationDetails';

export default {
  components: {
    PermissionAccessModal,
    Loader,
    registrationDetailsPopup,
    RegwatchDescriptionModal
  },
  props: {
    permissions: Array,
    searchRegulatory: String,
    filterCollapse: Boolean,
    selectedMenu: String,
    regulatoryUpdateList: Object,
    isFromGlobalSearch: Boolean,
    globalSearchFilteredData: Object
  },
  data() {
    return {
      notifications: {},
      selectedRegWatch: {},
      onHover: [],
      listToRender: [],
      isFlagged: false,
      seeMore: true,
      loaderStatus: false,
      activeProductRegistration: {},
      editFlag: false
    };
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    openDescriptionModal(regUpdate) {
      this.selectedRegWatch = { ...regUpdate };
      $('#reg-watch-description-modal').modal({
        backdrop: 'static',
        keyboard: false
      });
    },

    mouseOver(regId, productList) {
      let flag = false;
      productList.some((product) => {
        if (product.name && product.name.length >= 80) {
          flag = true;
          return product.name;
        }
        return false;
      });
      if (flag) this.$set(this.onHover, regId, true);
    },
    unArchiveRegulatory(id) {
      this.$emit('unArchiveRegulatory', id);
    },
    archiveRegulatory(id, countryId) {
      this.$emit('archiveRegulatory', id, countryId);
    },
    deleteRegulatoryFromNew(id, countryId) {
      this.$emit('deleteRegulatoryFromNew', id, countryId);
    },
    updateFlag(flag, id, countryId) {
      this.$emit('updateFlag', flag, id, countryId);
    },
    viewMore(id) {
      this.notifications = {
        ...this.notifications,
        [`${id}`]: !this.notifications[`${id}`]
      };
    },
    disableLoader() {
      this.loaderStatus = false;
    },
    async getProductRelatedDetails(regiId) {
      if (this.permissions.indexOf('REG_TRACKER_RECORDS') === -1) {
        $('#permissionAccessModal').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else if (regiId !== undefined) {
        this.loaderStatus = true;
        const row = await getRegistrationDetailsById(regiId);
        this.loaderStatus = false;
        if (row && row.error) {
          this.clearNotifications();
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Registration is not found!',
            group: 'custom-notification'
          });
        } else if (row) {
          const entry = constructRegistrationObject(row);
          this.viewRegistration(entry);
        }
      }
    },
    viewRegistration(record) {
      this.activeProductRegistration = record;
      this.activeId = record.registrationId;
      $('#registrationDetail').modal();
      this.loaderStatus = false;
    },
    hidePopup(value) {
      this.editFlag = value;
    },
    updateListToRender(flag) {
      this.listToRender = [];
      this.loaderStatus = true;
      this.listToRender = this.isFromGlobalSearch
        ? this.globalSearchFilteredData.viewAll
        : this.regulatoryUpdateList[this.selectedMenu];
      if (flag) {
        setTimeout(this.disableLoader, 1000);
      } else {
        this.loaderStatus = false;
      }
    },
    countryFlag(code) {
      if (code) {
        return `flag-icon-${code.toLowerCase()}`;
      }
      return '';
    },
    seeMoreOption(id, desc) {
      const seeFlag = desc;
      const regObj = this.listToRender.find((obj) => obj.id === id);
      if (seeFlag === 'seemore') {
        regObj.seeMore = false;
        regObj.seeless = true;
      } else if (seeFlag === 'seeless') {
        regObj.seeMore = true;
        regObj.seeless = false;
      }
    }
  },
  filters: {
    highlight(words, searchRegulatory) {
      if (searchRegulatory === '') {
        return words;
      }
      if (words !== null) {
        const filterHighlight = searchRegulatory.split(' ');

        const pattern = `(|\\b)(${filterHighlight.join('|')})`;
        const patternString = new RegExp(pattern, 'gi');
        const filteredText = words.replace(patternString, '<span class="highlight">$2</span>');
        return filteredText;
      }
      return '';
    }
  },
  computed: {
    filteredListToRender() {
      if (!this.isFromGlobalSearch) {
        return this.listToRender.filter(
          (regulatoryObj) =>
            regulatoryObj.title.toLowerCase().match(this.searchRegulatory.toLowerCase()) ||
            regulatoryObj.longDescription.toLowerCase().match(this.searchRegulatory.toLowerCase())
        );
      }
      return this.listToRender;
    }
  },
  watch: {
    filteredListToRender() {
      this.$root.$emit('filteredRegulatoryLength', this.filteredListToRender.length);
      if (!this.searchRegulatory) {
        this.loaderStatus = true;
        setTimeout(this.disableLoader, 200);
      }
    },
    regulatoryUpdateList() {
      if (!this.isFromGlobalSearch) {
        this.updateListToRender();
      }
    },
    isFromGlobalSearch: {
      handler(newValue) {
        if (newValue) this.listToRender = this.globalSearchFilteredData.viewAll;
        else {
          this.updateListToRender(true);
        }
      }
    },
    selectedMenu(newVal, prevVal) {
      if (newVal !== prevVal) {
        this.updateListToRender(true);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/* .ul-list {
  right: 100px;
} */
.justify-space-between {
  justify-content: space-between;
}
.img-16 {
  height: 16px;
  width: 16px;
}
.text-secondary {
  color: rgba(0, 0, 0, 0.7);
}
.text-primary {
  color: #0b3c61;
}
.reg-content {
  padding: 0px 10px 0px 32px;
}
.learn-more-text {
  color: #2f80ed;
  line-height: 19px;
}
.flag-icon.flag-icon-squared {
  width: 20px;
  height: 20px;
}
.dropdown {
  .dropdown-menu {
    display: none;
  }
}
.dropdown-menu {
  > li {
    > a {
      padding: 0px;
    }
  }
  position: absolute;
  top: 30px;
  transform: translateX(-70%);
  background: #ffffff;
  box-shadow: 2px 4px 10px rgb(0 0 0 / 25%);
  border-radius: 5px;
  padding: 5px 0px;
  &:after {
    content: '';
    position: absolute;
    width: 19px;
    height: 19px;
    background: #ffffff;
    top: -10px;
    visibility: visible;
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    border-left: 1px solid rgba(0, 0, 0, 0.15);
    transform: rotate(45deg);
  }
  .product-list {
    max-height: 200px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-right: 5px;
  }
}
.menu-btn {
  background: transparent;
  border: none;
}
.word-break {
  word-break: break-word;
}
.dropdown.open {
  .dropdown-menu {
    display: block;
  }
  .dropdown-menu.display-none {
    display: none;
  }
}
.arrow-open[aria-expanded='true'] {
  transform: rotate(180deg);
}
.dropdown-menu.reg-affected {
  &::after {
    right: 24px;
  }
  min-width: 170px;
}
.product-list {
  li {
    white-space: nowrap;
  }
}
.dropdown-menu.left-actions {
  left: 90px;
  &:after {
    left: 20px;
  }
}
p {
  margin: 0px;
}
li {
  padding: 2px 15px;
}
#trackerActionDots {
  .dropdown-menu {
    top: 40px;
  }
}
.regupdate-title {
  font-size: 22px;
  color: #0b3c61;
  word-wrap: break-word;
}
.fa-ellipsis-v {
  &:before {
    content: url('/static/images/icons/menudots_icon.svg');
  }
}
.menu-btn[aria-expanded='true'] {
  .fa-ellipsis-v {
    &:before {
      filter: brightness(2.1);
    }
  }
}
.notification-box {
  background: #ffffff;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin: 15px 0px 10px 0px;
  padding: 26px 26px 26px 30px;
}
.ul-list {
  li {
    padding-left: 0px;
  }
  padding-inline-start: 0px;
  list-style-type: none;
  margin: 0px;
}
.font-properties {
  font-family: Roboto;
  font-style: normal;
}
.reg-title {
  padding-top: 2px;
}
@media only screen and (max-width: 576px) {
  .learn-more-text {
    margin: auto;
  }
  .justify-space-between {
    flex-direction: column;
    row-gap: 24px;
  }
}
</style>
